import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { ObjetoComfenalcoEntity } from 'src/app/services/servicio-comfenalco.service';

@Component({
  selector: 'app-body-comfenalco',
  templateUrl: './body-comfenalco.component.html',
  styleUrls: ['./body-comfenalco.component.css']
})
export class BodyComfenalcoComponent implements OnInit, OnChanges {

  @Input() public arrayObjetoComfenalcoEntity : ObjetoComfenalcoEntity[] = [];

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.getArrayObjetoComfenalco();
  }

  private async getArrayObjetoComfenalco() {
    try {
      await this.arrayObjetoComfenalcoEntity;
    }catch(exception){
      console.log(exception);
    }
  }

}
